// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LoginPage-Wrapper-3XYh5W","Wrapper_fourthree":"LoginPage-Wrapper_fourthree-3Ugbso"};